import axios from 'axios';
import { takeEvery, call, put } from 'redux-saga/effects';
import * as types from './types';
import config from '../../config/app_config';
import { getClient } from '../../common/utils';

export function* updatePerkServiceWatcherSaga() {
  yield takeEvery(types.UPDATE_PERK_SERVICE_CALL_REQUEST, workerSaga);
}

export function updateData(data) {
  const client = getClient();
  const url = `${config.API_ROOT_URL}/v1/offer/${client}/perkservice/`;

  return axios.patch(url, data)
    .then(val => val)
    .catch(err => err.response);
}

export function* workerSaga(action) {
  try {
    const { data } = action;

    yield put({
      type: types.GET_PERK_SERVICE_CALL_SUCCESS,
      data: {
        results: data
      }});
    const response = yield call(updateData, data);

    if (response && response.status >= 200 && response.status < 202) {
      yield put({ type: types.UPDATE_PERK_SERVICE_CALL_SUCCESS });
      yield put({ type: types.GET_PERK_SERVICE_CALL_REQUEST });
    } else {
      yield put({ type: types.UPDATE_PERK_SERVICE_CALL_FAILURE, error: response && response.data });
    }
  } catch (error) {
    yield put({ type: types.UPDATE_PERK_SERVICE_CALL_FAILURE, 'error': error && error.data});
  }
}
